// eslint-disable-next-line no-shadow
export enum QuestionnaireType {
  IMPACT_SCAN = 'IMPACT_SCAN',
  ASSESSMENT = 'ASSESSMENT',
}
